
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {OrdersClosedSummariesGetResponse} from './OrdersClosedSummariesGetResponse';

/**
 * OrdersClosedSummariesGetRequest struct
 */
class OrdersClosedSummariesGetRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {Date=} requestFrom
   * @param {Date=} requestTo
   * @param {!Set=} accountLogins
   * @param {number=} managerLogin
   * @param {number=} orderId
   * @param {UUID=} platformId
   * @param {!boolean=} filterAccountGroups
   * @param {!Set=} accountGroup
   * @param {!boolean=} filterSymbols
   * @param {!Set=} symbols
   * @param {!Set=} externalClientIds
   * @constructor
   */
  constructor (parent = new Request(), requestFrom = null, requestTo = null, accountLogins = new Set(), managerLogin = null, orderId = null, platformId = null, filterAccountGroups = false, accountGroup = new Set(), filterSymbols = false, symbols = new Set(), externalClientIds = new Set()) {
    super()
    super.copy(parent)
    this.RequestFrom = requestFrom
    this.RequestTo = requestTo
    this.AccountLogins = accountLogins
    this.ManagerLogin = managerLogin
    this.OrderId = orderId
    this.PlatformId = platformId
    this.FilterAccountGroups = filterAccountGroups
    this.AccountGroup = accountGroup
    this.FilterSymbols = filterSymbols
    this.Symbols = symbols
    this.ExternalClientIds = externalClientIds
  }

  /**
   * Copy struct (shallow copy)
   * @this {!OrdersClosedSummariesGetRequest}
   * @param {!OrdersClosedSummariesGetRequest} other Other struct
   * @returns {!OrdersClosedSummariesGetRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.RequestFrom != null) {
      if (other.RequestFrom instanceof Date) {
        this.RequestFrom = new Date(other.RequestFrom.getTime())
      } else {
        this.RequestFrom = new Date(Math.round(other.RequestFrom / 1000000))
      }
    } else {
      this.RequestFrom = null
    }
    if (other.RequestTo != null) {
      if (other.RequestTo instanceof Date) {
        this.RequestTo = new Date(other.RequestTo.getTime())
      } else {
        this.RequestTo = new Date(Math.round(other.RequestTo / 1000000))
      }
    } else {
      this.RequestTo = null
    }
    if (other.AccountLogins != null) {
      this.AccountLogins = new Set()
      for (let item of other.AccountLogins) {
        if (item != null) {
          let tempItem
          tempItem = UInt64.fromNumber(item)
          this.AccountLogins.add(tempItem)
        } else {
          this.AccountLogins.add(null)
        }
      }
    } else {
      this.AccountLogins = null
    }
    if (other.ManagerLogin != null) {
      this.ManagerLogin = UInt64.fromNumber(other.ManagerLogin)
    } else {
      this.ManagerLogin = null
    }
    if (other.OrderId != null) {
      this.OrderId = UInt64.fromNumber(other.OrderId)
    } else {
      this.OrderId = null
    }
    if (other.PlatformId != null) {
      this.PlatformId = new UUID(other.PlatformId)
    } else {
      this.PlatformId = null
    }
    if (other.FilterAccountGroups != null) {
      this.FilterAccountGroups = other.FilterAccountGroups
    } else {
      this.FilterAccountGroups = null
    }
    if (other.AccountGroup != null) {
      this.AccountGroup = new Set()
      for (let item of other.AccountGroup) {
        if (item != null) {
          let tempItem
          tempItem = new UUID(item)
          this.AccountGroup.add(tempItem)
        } else {
          this.AccountGroup.add(null)
        }
      }
    } else {
      this.AccountGroup = null
    }
    if (other.FilterSymbols != null) {
      this.FilterSymbols = other.FilterSymbols
    } else {
      this.FilterSymbols = null
    }
    if (other.Symbols != null) {
      this.Symbols = new Set()
      for (let item of other.Symbols) {
        if (item != null) {
          let tempItem
          tempItem = new UUID(item)
          this.Symbols.add(tempItem)
        } else {
          this.Symbols.add(null)
        }
      }
    } else {
      this.Symbols = null
    }
    if (other.ExternalClientIds != null) {
      this.ExternalClientIds = new Set()
      for (let item of other.ExternalClientIds) {
        if (item != null) {
          let tempItem
          tempItem = item
          this.ExternalClientIds.add(tempItem)
        } else {
          this.ExternalClientIds.add(null)
        }
      }
    } else {
      this.ExternalClientIds = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!OrdersClosedSummariesGetRequest}
   * @returns {!OrdersClosedSummariesGetRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new OrdersClosedSummariesGetRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new OrdersClosedSummariesGetRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!OrdersClosedSummariesGetRequest}
   * @param {!OrdersClosedSummariesGetRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof OrdersClosedSummariesGetRequest)) {
      throw new TypeError('Instance of OrdersClosedSummariesGetRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!OrdersClosedSummariesGetRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      RequestFrom: ((this.RequestFrom != null) ? (this.RequestFrom.getTime() * 1000000) : null),
      RequestTo: ((this.RequestTo != null) ? (this.RequestTo.getTime() * 1000000) : null),
      AccountLogins: ((this.AccountLogins != null) ? Array.from(this.AccountLogins, item => ((item != null) ? item.toNumber() : null)) : null),
      ManagerLogin: ((this.ManagerLogin != null) ? this.ManagerLogin.toNumber() : null),
      OrderId: ((this.OrderId != null) ? this.OrderId.toNumber() : null),
      PlatformId: ((this.PlatformId != null) ? this.PlatformId.toString() : null),
      FilterAccountGroups: ((this.FilterAccountGroups != null) ? this.FilterAccountGroups : null),
      AccountGroup: ((this.AccountGroup != null) ? Array.from(this.AccountGroup, item => ((item != null) ? item.toString() : null)) : null),
      FilterSymbols: ((this.FilterSymbols != null) ? this.FilterSymbols : null),
      Symbols: ((this.Symbols != null) ? Array.from(this.Symbols, item => ((item != null) ? item.toString() : null)) : null),
      ExternalClientIds: ((this.ExternalClientIds != null) ? Array.from(this.ExternalClientIds, item => ((item != null) ? item : null)) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return OrdersClosedSummariesGetRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!OrdersClosedSummariesGetRequest} other Object value
   * @returns {!OrdersClosedSummariesGetRequest} Created struct
   */
  static fromObject (other) {
    return new OrdersClosedSummariesGetRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!OrdersClosedSummariesGetRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return OrdersClosedSummariesGetRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!OrdersClosedSummariesGetRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 4057
  }
}

export { OrdersClosedSummariesGetRequest };

/**
 * Fast Binary Encoding OrdersClosedSummariesGetRequest field model
 */
class FieldModelOrdersClosedSummariesGetRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.RequestFrom = new fbe.FieldModelOptional(new fbe.FieldModelTimestamp(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.RequestTo = new fbe.FieldModelOptional(new fbe.FieldModelTimestamp(buffer, this.RequestFrom.fbeOffset + this.RequestFrom.fbeSize), buffer, this.RequestFrom.fbeOffset + this.RequestFrom.fbeSize)
    this.AccountLogins = new fbe.FieldModelSet(new fbe.FieldModelUInt64(buffer, this.RequestTo.fbeOffset + this.RequestTo.fbeSize), buffer, this.RequestTo.fbeOffset + this.RequestTo.fbeSize)
    this.ManagerLogin = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.AccountLogins.fbeOffset + this.AccountLogins.fbeSize), buffer, this.AccountLogins.fbeOffset + this.AccountLogins.fbeSize)
    this.OrderId = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.ManagerLogin.fbeOffset + this.ManagerLogin.fbeSize), buffer, this.ManagerLogin.fbeOffset + this.ManagerLogin.fbeSize)
    this.PlatformId = new fbe.FieldModelOptional(new fbe.FieldModelUUID(buffer, this.OrderId.fbeOffset + this.OrderId.fbeSize), buffer, this.OrderId.fbeOffset + this.OrderId.fbeSize)
    this.FilterAccountGroups = new fbe.FieldModelBool(buffer, this.PlatformId.fbeOffset + this.PlatformId.fbeSize)
    this.AccountGroup = new fbe.FieldModelSet(new fbe.FieldModelUUID(buffer, this.FilterAccountGroups.fbeOffset + this.FilterAccountGroups.fbeSize), buffer, this.FilterAccountGroups.fbeOffset + this.FilterAccountGroups.fbeSize)
    this.FilterSymbols = new fbe.FieldModelBool(buffer, this.AccountGroup.fbeOffset + this.AccountGroup.fbeSize)
    this.Symbols = new fbe.FieldModelSet(new fbe.FieldModelUUID(buffer, this.FilterSymbols.fbeOffset + this.FilterSymbols.fbeSize), buffer, this.FilterSymbols.fbeOffset + this.FilterSymbols.fbeSize)
    this.ExternalClientIds = new fbe.FieldModelSet(new fbe.FieldModelString(buffer, this.Symbols.fbeOffset + this.Symbols.fbeSize), buffer, this.Symbols.fbeOffset + this.Symbols.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelOrdersClosedSummariesGetRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelOrdersClosedSummariesGetRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelOrdersClosedSummariesGetRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.RequestFrom.fbeSize + this.RequestTo.fbeSize + this.AccountLogins.fbeSize + this.ManagerLogin.fbeSize + this.OrderId.fbeSize + this.PlatformId.fbeSize + this.FilterAccountGroups.fbeSize + this.AccountGroup.fbeSize + this.FilterSymbols.fbeSize + this.Symbols.fbeSize + this.ExternalClientIds.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelOrdersClosedSummariesGetRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.RequestFrom.fbeExtra + this.RequestTo.fbeExtra + this.AccountLogins.fbeExtra + this.ManagerLogin.fbeExtra + this.OrderId.fbeExtra + this.PlatformId.fbeExtra + this.FilterAccountGroups.fbeExtra + this.AccountGroup.fbeExtra + this.FilterSymbols.fbeExtra + this.Symbols.fbeExtra + this.ExternalClientIds.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelOrdersClosedSummariesGetRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelOrdersClosedSummariesGetRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelOrdersClosedSummariesGetRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 4057
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelOrdersClosedSummariesGetRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelOrdersClosedSummariesGetRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.RequestFrom.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.RequestFrom.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RequestFrom.fbeSize

    if ((fbeCurrentSize + this.RequestTo.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.RequestTo.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RequestTo.fbeSize

    if ((fbeCurrentSize + this.AccountLogins.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountLogins.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountLogins.fbeSize

    if ((fbeCurrentSize + this.ManagerLogin.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ManagerLogin.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ManagerLogin.fbeSize

    if ((fbeCurrentSize + this.OrderId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderId.fbeSize

    if ((fbeCurrentSize + this.PlatformId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.PlatformId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PlatformId.fbeSize

    if ((fbeCurrentSize + this.FilterAccountGroups.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.FilterAccountGroups.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FilterAccountGroups.fbeSize

    if ((fbeCurrentSize + this.AccountGroup.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountGroup.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountGroup.fbeSize

    if ((fbeCurrentSize + this.FilterSymbols.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.FilterSymbols.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FilterSymbols.fbeSize

    if ((fbeCurrentSize + this.Symbols.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Symbols.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Symbols.fbeSize

    if ((fbeCurrentSize + this.ExternalClientIds.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ExternalClientIds.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExternalClientIds.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelOrdersClosedSummariesGetRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelOrdersClosedSummariesGetRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelOrdersClosedSummariesGetRequest}
   * @param {!OrdersClosedSummariesGetRequest} fbeValue Default value, defaults is new OrdersClosedSummariesGetRequest()
   * @returns {!OrdersClosedSummariesGetRequest} OrdersClosedSummariesGetRequest value
   */
  get (fbeValue = new OrdersClosedSummariesGetRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelOrdersClosedSummariesGetRequest}
   * @param {!OrdersClosedSummariesGetRequest} fbeValue OrdersClosedSummariesGetRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.RequestFrom.fbeSize) <= fbeStructSize) {
      fbeValue.RequestFrom = this.RequestFrom.get()
    } else {
      fbeValue.RequestFrom = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RequestFrom.fbeSize

    if ((fbeCurrentSize + this.RequestTo.fbeSize) <= fbeStructSize) {
      fbeValue.RequestTo = this.RequestTo.get()
    } else {
      fbeValue.RequestTo = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RequestTo.fbeSize

    if ((fbeCurrentSize + this.AccountLogins.fbeSize) <= fbeStructSize) {
      this.AccountLogins.get(fbeValue.AccountLogins)
    } else {
      fbeValue.AccountLogins.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountLogins.fbeSize

    if ((fbeCurrentSize + this.ManagerLogin.fbeSize) <= fbeStructSize) {
      fbeValue.ManagerLogin = this.ManagerLogin.get()
    } else {
      fbeValue.ManagerLogin = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ManagerLogin.fbeSize

    if ((fbeCurrentSize + this.OrderId.fbeSize) <= fbeStructSize) {
      fbeValue.OrderId = this.OrderId.get()
    } else {
      fbeValue.OrderId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderId.fbeSize

    if ((fbeCurrentSize + this.PlatformId.fbeSize) <= fbeStructSize) {
      fbeValue.PlatformId = this.PlatformId.get()
    } else {
      fbeValue.PlatformId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PlatformId.fbeSize

    if ((fbeCurrentSize + this.FilterAccountGroups.fbeSize) <= fbeStructSize) {
      fbeValue.FilterAccountGroups = this.FilterAccountGroups.get(false)
    } else {
      fbeValue.FilterAccountGroups = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FilterAccountGroups.fbeSize

    if ((fbeCurrentSize + this.AccountGroup.fbeSize) <= fbeStructSize) {
      this.AccountGroup.get(fbeValue.AccountGroup)
    } else {
      fbeValue.AccountGroup.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountGroup.fbeSize

    if ((fbeCurrentSize + this.FilterSymbols.fbeSize) <= fbeStructSize) {
      fbeValue.FilterSymbols = this.FilterSymbols.get(false)
    } else {
      fbeValue.FilterSymbols = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FilterSymbols.fbeSize

    if ((fbeCurrentSize + this.Symbols.fbeSize) <= fbeStructSize) {
      this.Symbols.get(fbeValue.Symbols)
    } else {
      fbeValue.Symbols.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Symbols.fbeSize

    if ((fbeCurrentSize + this.ExternalClientIds.fbeSize) <= fbeStructSize) {
      this.ExternalClientIds.get(fbeValue.ExternalClientIds)
    } else {
      fbeValue.ExternalClientIds.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExternalClientIds.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelOrdersClosedSummariesGetRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelOrdersClosedSummariesGetRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelOrdersClosedSummariesGetRequest}
   * @param {!OrdersClosedSummariesGetRequest} fbeValue OrdersClosedSummariesGetRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelOrdersClosedSummariesGetRequest}
   * @param {OrdersClosedSummariesGetRequest} fbeValue OrdersClosedSummariesGetRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.RequestFrom.set(fbeValue.RequestFrom)
    this.RequestTo.set(fbeValue.RequestTo)
    this.AccountLogins.set(fbeValue.AccountLogins)
    this.ManagerLogin.set(fbeValue.ManagerLogin)
    this.OrderId.set(fbeValue.OrderId)
    this.PlatformId.set(fbeValue.PlatformId)
    this.FilterAccountGroups.set(fbeValue.FilterAccountGroups)
    this.AccountGroup.set(fbeValue.AccountGroup)
    this.FilterSymbols.set(fbeValue.FilterSymbols)
    this.Symbols.set(fbeValue.Symbols)
    this.ExternalClientIds.set(fbeValue.ExternalClientIds)
  }
}

export { FieldModelOrdersClosedSummariesGetRequest };

/**
 * Fast Binary Encoding OrdersClosedSummariesGetRequest model
 */
class OrdersClosedSummariesGetRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelOrdersClosedSummariesGetRequest(this.buffer, 4)
  }

  /**
   * Get the OrdersClosedSummariesGetRequest model
   * @this {!OrdersClosedSummariesGetRequestModel}
   * @returns {!FieldModelOrdersClosedSummariesGetRequest} model OrdersClosedSummariesGetRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!OrdersClosedSummariesGetRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!OrdersClosedSummariesGetRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return OrdersClosedSummariesGetRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!OrdersClosedSummariesGetRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelOrdersClosedSummariesGetRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!OrdersClosedSummariesGetRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!OrdersClosedSummariesGetRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!OrdersClosedSummariesGetRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!OrdersClosedSummariesGetRequestModel}
   * @param {!OrdersClosedSummariesGetRequest} value OrdersClosedSummariesGetRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!OrdersClosedSummariesGetRequestModel}
   * @param {!OrdersClosedSummariesGetRequest} value OrdersClosedSummariesGetRequest value, defaults is new OrdersClosedSummariesGetRequest()
   * @return {!object} Deserialized OrdersClosedSummariesGetRequest value and its size
   */
  deserialize (value = new OrdersClosedSummariesGetRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new OrdersClosedSummariesGetRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new OrdersClosedSummariesGetRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!OrdersClosedSummariesGetRequestModel}
   * @param {!number} prev Previous OrdersClosedSummariesGetRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { OrdersClosedSummariesGetRequestModel };
OrdersClosedSummariesGetRequest.__has_response = true;
OrdersClosedSummariesGetRequest.__response_class = OrdersClosedSummariesGetResponse;
